/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locationoverridewarning2Inputs */

const en_locationoverridewarning2 = /** @type {(inputs: Locationoverridewarning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are using a different address than the linked listing.`)
};

const de_locationoverridewarning2 = /** @type {(inputs: Locationoverridewarning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du verwendest eine andere Adresse als beim verknüpften Ort.`)
};

/**
* | output |
* | --- |
* | "You are using a different address than the linked listing." |
*
* @param {Locationoverridewarning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const locationoverridewarning2 = /** @type {((inputs?: Locationoverridewarning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locationoverridewarning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_locationoverridewarning2(inputs)
	return de_locationoverridewarning2(inputs)
});
export { locationoverridewarning2 as "locationOverrideWarning" }